import { createAction } from 'redux-actions'

export const SET_COMPANY = createAction('SET_COMPANY')
